import React from 'react'

export default function InspectorLandingPage() {
  return (
    <div>InspectorLandingPage</div>
  )
}
